module.exports = __webpack_public_path__ + "img/ml3078.d0fd372f.png";